module.exports = __webpack_public_path__ + "img/item6.7ffe14c3.png";